<div class="login-content" [class.loading]="isLoading">
  <ng-container *ngIf="isUrlLinkValid; else loading">
    <a href="/" class="login-logo">
      <img src="./assets/img/logo.png" alt="Logo" />
    </a>

    <form class="login-form" [formGroup]="resetPasswordForm">
      <h1 class="login-title mb-3">Create Account Password</h1>

      <div class="mb-3">
        <span class="input-label">New Password</span>
        <input
          type="password"
          class="input"
          placeholder="Enter Password"
          formControlName="password"
          password-toggle
          [class.is-invalid]="
            resetPasswordForm.get('password')?.invalid &&
            resetPasswordForm.get('password')?.touched
          "
        />

        <div
          class="invalid-feedback d-block text-left"
          *ngIf="
            resetPasswordForm.get('password')?.invalid &&
            resetPasswordForm.get('password')?.touched
          "
        >
          <div *ngIf="resetPasswordForm.get('password')?.errors?.required">
            This field is required
          </div>
          <div
            *ngIf="resetPasswordForm.get('password')?.errors?.sameAsOriginal"
          >
            Password field not equal to Password
          </div>

          <!-- <div *ngIf="resetPasswordForm.get('password')?.errors?.pattern">
              Password should match next requirements:
                <br />- Passwords must have at least one lowercase ('a'-'z').
                <br />- Passwords must have at least one uppercase ('A'-'Z').
                <br />- Passwords must have at least one non alphanumeric character.
                <br />- Passwords must have at least one digit ('0'-'9').
            </div> -->

          <div
            *ngIf="
              resetPasswordForm.get('password')?.errors?.passwordRequirments
            "
            [innerHTML]="
              resetPasswordForm.get('password')?.errors?.passwordRequirments
            "
            style="white-space: pre-line"
          ></div>
        </div>
      </div>

      <div class="form-row mb-3">
        <div [class.col-12]="isPasswordReset" [class.col-8]="!isPasswordReset">
          <span class="input-label">Confirm New Password</span>
          <input
            type="password"
            class="input"
            placeholder="Enter Password"
            formControlName="confirmPassword"
            password-toggle
            [class.is-invalid]="
              resetPasswordForm.get('confirmPassword')?.invalid &&
              resetPasswordForm.get('confirmPassword')?.touched
            "
          />
        </div>

        <div class="col-4" *ngIf="!isPasswordReset">
          <span class="input-label">Pin number</span>
          <input
            type="text"
            class="input"
            formControlName="pin"
            placeholder="Pin number"
            [class.is-invalid]="
              resetPasswordForm.get('pin')?.invalid &&
              resetPasswordForm.get('pin')?.touched
            "
          />
        </div>

        <div
          class="invalid-feedback d-block text-left"
          *ngIf="
            resetPasswordForm.get('confirmPassword')?.invalid &&
            resetPasswordForm.get('confirmPassword')?.touched
          "
        >
          <div
            *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.required"
          >
            This field is required
          </div>

          <div
            *ngIf="
              resetPasswordForm.get('confirmPassword')?.errors?.sameAsOriginal
            "
          >
            Confirm Password field not equal to Password
          </div>

          <div
            *ngIf="
              resetPasswordForm.get('password')?.errors?.passwordRequirments
            "
            [innerHTML]="
              resetPasswordForm.get('password')?.errors?.passwordRequirments
            "
            style="white-space: pre-line"
          ></div>
        </div>

        <div
          class="invalid-feedback d-block text-left"
          *ngIf="
            resetPasswordForm.get('pin') &&
            resetPasswordForm.get('pin')?.invalid &&
            resetPasswordForm.get('pin')?.touched
          "
        >
          <div *ngIf="resetPasswordForm.get('pin')?.errors?.required">
            This field is required
          </div>
          <div
            *ngIf="
              (resetPasswordForm.get('pin')?.errors?.minlength &&
                resetPasswordForm.get('pin')?.errors?.minlength
                  .requiredLength) ||
              (resetPasswordForm.get('pin')?.errors?.maxlength &&
                resetPasswordForm.get('pin')?.errors?.maxlength.requiredLength)
            "
          >
            Pin length must be
            {{
              resetPasswordForm.get('pin')?.errors?.minlength?.requiredLength ||
                resetPasswordForm.get('pin')?.errors?.maxlength?.requiredLength
            }}
            characters
          </div>
        </div>
      </div>

      <div class="mt-3 pt-2">
        <button
          type="submit"
          class="button blue w-100"
          [disabled]="resetPasswordForm.invalid"
          (click)="onSubmit()"
        >
          Submit
        </button>
      </div>
    </form>
  </ng-container>
</div>

<ng-template #loading>
  <loader style="height: 340px"></loader>
</ng-template>
